import React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RiFileExcel2Fill } from 'react-icons/ri';

function DeliveryUpdateModal(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Tooltip label={t('Modifier via Excel')} placement="top">
            <IconButton
                icon={<RiFileExcel2Fill />}
                onClick={() => navigate('/ModifyOrdersExcel')}
                colorScheme="purple"
                variant="outline"
                rounded="xl"
                aria-label={t("Modifier via Excel")}
                title={t("Modifier via Excel")}
                {...props}
            />
        </Tooltip>
    );
}

export default DeliveryUpdateModal;
